export enum QuizProgressPopUpContentType {
	TOPIC = 'topic',
	QUESTION = 'question'
}